import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";
import { getEntityByToken } from "../get_entity";

const RECENTLY_VIEWED_PRODUCT_TOKENS = [
  "p_k8zac7przz",
  "p_4ynyj23hdg",
  "p_t5pqsyjps7",
  "p_sxjw4pr3v2",
  "p_7ypzb8z9d5",
  "p_qznmydksnm",
  "p_8ty7kjf8pc",
  "p_z69ucn37ph",
  "p_g9gywb5t6x",
  "p_3c9objikox",
  "p_ad85islrx1",
  "p_dqr8zyxt2k",
];

export const recentlyViewedProducts: FaireProductEntity[] =
  RECENTLY_VIEWED_PRODUCT_TOKENS.map((token) =>
    getEntityByToken(token, "product")
  ).filter(
    (product: FaireProductEntity | undefined): product is FaireProductEntity =>
      product !== undefined
  );
